import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DataService } from '../../data/data.service';

@Directive({
  selector: '[appRolesNeg]'
})
export class RolesNegDirective {

  private usuarioLog: DataService;
  private permisosUser;
  private permisosNes;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dataService: DataService,
  ) { }

  @Input() set appRolesNeg(val: Array<string>){
    this.permisosNes = val;
    this.usuarioLog = this.dataService;
    this.permisosUser = this.usuarioLog.role;
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.actualizarVistaNeg();
  }

  private actualizarVistaNeg(){
    this.viewContainer.clear();
    if(this.revisarPermisosNeg()){
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  private revisarPermisosNeg(): boolean{
    let tienePermiso = true;
    if(this.permisosUser && this.permisosNes){
        const permisoEncontrado = this.permisosNes.find( per => {
          return ( per.toUpperCase() === this.permisosUser.toUpperCase() );
        });
        if(permisoEncontrado){
          tienePermiso = false;
        }
    }
    return tienePermiso;
  }
}
